module.exports = __webpack_public_path__ + "static/media/download-button-svgrepo-com.bf53a6e0.svg";